import './participantConsumerCategorySelector.scss';

import { FormattedMessage } from 'react-intl';
import {
  ActionIcon,
  ActionIconColor,
  ActionIconShape,
  ActionIconVariant,
  Size,
} from '@eliberty/design-system-react';

import { ConsumerCategory } from '~types/appsync.types';

interface Props {
  consumerCategories?: ConsumerCategory[];
  participantsLimit?: number;
  counts: Record<string, number>;
  onIncrement: (shortname: string) => void;
  onDecrement: (shortname: string) => void;
}

const ParticipantConsumerCategorySelector = ({
  consumerCategories,
  participantsLimit,
  counts,
  onIncrement,
  onDecrement,
}: Props) => {
  const totalCount = Object.values(counts).reduce((acc, val) => acc + val, 0);

  return (
    <div className='ParticipantConsumerCategorySelector'>
      <div className='ParticipantConsumerCategorySelector_content'>
        {consumerCategories?.map(({ shortname, name, ageMin, ageMax }) => (
          <div className='ParticipantConsumerCategorySelector_row' key={shortname}>
            <div className='ParticipantConsumerCategorySelector_label'>
              <div>{name}</div>
              <div className='ParticipantConsumerCategorySelector_subLabel'>
                (
                <FormattedMessage
                  id='yearsRange'
                  defaultMessage='{ageMin} - {ageMax} years old'
                  values={{ ageMax, ageMin }}
                />
                )
              </div>
            </div>
            <div className='ParticipantConsumerCategorySelector_counter'>
              <ActionIcon
                icon='action-minus'
                label='Icon minus'
                size={Size.S}
                variant={ActionIconVariant.Filled}
                color={ActionIconColor.Primary}
                shape={ActionIconShape.Round}
                onClick={() => onDecrement(shortname)}
                disabled={(counts[shortname] ?? 0) === 0}
                data-testid={`ConsumerCategoryCard_decrement_${shortname}`}
              />
              <span
                className={`ParticipantConsumerCategorySelector_count ${
                  (counts[shortname] ?? 0) === 0
                    ? 'ParticipantConsumerCategorySelector_count-disabled'
                    : ''
                }`}
                data-testid={`ConsumerCategoryCard_count_${shortname}`}
              >
                {counts[shortname] ?? 0}
              </span>
              <ActionIcon
                icon='action-plus'
                label='Icon plus'
                size={Size.S}
                variant={ActionIconVariant.Filled}
                color={ActionIconColor.Primary}
                shape={ActionIconShape.Round}
                onClick={() => onIncrement(shortname)}
                disabled={participantsLimit ? totalCount === participantsLimit : false}
                data-testid={`ConsumerCategoryCard_increment_${shortname}`}
              />
            </div>
          </div>
        ))}

        {participantsLimit !== undefined && totalCount === participantsLimit && (
          <div className='ParticipantConsumerCategorySelector_errorMessage'>
            <FormattedMessage
              id='participantsReachedLimit'
              defaultMessage='The maximum number of participants was reached.'
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default ParticipantConsumerCategorySelector;
